// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Paper,
//   TextField,
//   Button,
//   Grid,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Select,
//   Switch,
//   FormControlLabel,
//   Divider,
//   Alert,
//   CircularProgress,
//   InputAdornment,
//   Chip,
//   OutlinedInput,
//   SelectChangeEvent,
//   IconButton,
//   Tooltip,
//   Radio,
//   RadioGroup,
// } from '@mui/material';
// import {
//   Save,
//   ArrowBack,
//   Person,
//   Email,
//   Work,
//   Business,
//   Phone,
//   LocationOn,
//   Security,
//   Schedule,
//   Notifications,
//   Api,
//   Info,
//   Add,
//   Delete,
// } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';
// import { useSnackbar } from 'notistack';
// import userApi, { CreateUserData } from '../../services/userApi';

// // Options for dropdowns
// const ROLES = [
//   { value: 'admin', label: 'Admin', description: 'Full system access including user management' },
//   { value: 'risk_analyst', label: 'Risk Analyst', description: 'Can view vendor risk data, run scans, analyze indicators, and generate reports' },
//   { value: 'viewer', label: 'Viewer', description: 'Read-only access to vendor risk data' },
//   { value: 'compliance_officer', label: 'Compliance Officer', description: 'Focus on compliance and regulatory indicators' },
// ];

// const DEPARTMENTS = ['IT', 'Security', 'Compliance', 'Risk Management', 'Finance', 'Legal', 'Operations', 'HR', 'Marketing', 'Sales'];
// const LOCATIONS = ['North America', 'EMEA', 'APAC', 'LATAM', 'Global'];
// const BUSINESS_UNITS = ['North America', 'EMEA', 'APAC', 'LATAM'];
// const VENDOR_CATEGORIES = ['Cloud Services', 'Technology Services', 'Logistics', 'Healthcare', 'Data & Analytics', 'Telecommunications', 'HR Services', 'IT Services', 'Finance', 'Legal', 'Cybersecurity'];
// const GEOGRAPHIES = ['North America', 'South America', 'Europe', 'Asia', 'Africa', 'Australia'];
// const CRITICALITY_LEVELS = ['Low', 'Medium', 'High', 'Critical'];

// export default function AddUser() {
//   const navigate = useNavigate();
//   const { enqueueSnackbar } = useSnackbar();
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState<CreateUserData>({
//     name: '',
//     email: '',
//     role: 'risk_analyst',
//     job_title: '',
//     department: '',
//     phone_number: '',
//     location: '',
//     max_active_sessions: 3,
//     session_timeout_hours: 8,
//     receive_notifications: true,
//     api_access: false,
//     send_invite: true,
//   });

//   // Data restrictions state
//   const [dataAccessScope, setDataAccessScope] = useState<'all' | 'restricted' | 'custom'>('all');
//   const [selectedBusinessUnits, setSelectedBusinessUnits] = useState<string[]>([]);
//   const [selectedVendors, setSelectedVendors] = useState<string[]>([]);
//   const [selectedRiskGroups, setSelectedRiskGroups] = useState<string[]>([]);
//   const [selectedVendorCategories, setSelectedVendorCategories] = useState<string[]>([]);
//   const [selectedGeographies, setSelectedGeographies] = useState<string[]>([]);
//   const [selectedCriticalityLevels, setSelectedCriticalityLevels] = useState<string[]>([]);

//   const handleChange = (field: keyof CreateUserData, value: any) => {
//     setFormData(prev => ({ ...prev, [field]: value }));
//   };

//   const handleSubmit = async () => {
//     if (!formData.name || !formData.email) {
//       enqueueSnackbar('Please fill in all required fields', { variant: 'error' });
//       return;
//     }

//     setLoading(true);
//     try {
//       await userApi.createUser(formData);
//       enqueueSnackbar('User created successfully! Invitation sent.', { variant: 'success' });
//       navigate('/users');
//     } catch (error: any) {
//       enqueueSnackbar(error.response?.data?.detail || 'Failed to create user', { variant: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh', p: 3 }}>
//       {/* Header */}
//       <Box sx={{ mb: 4 }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
//           <IconButton onClick={() => navigate('/users')} sx={{ color: '#64748b' }}>
//             <ArrowBack />
//           </IconButton>
//           <Typography variant="h4" sx={{ fontWeight: 700, color: '#0f172a' }}>
//             Add New User
//           </Typography>
//         </Box>
//         <Typography variant="body2" sx={{ color: '#64748b', ml: 7 }}>
//           Create a new user and define their role, permissions and data access.
//         </Typography>
//       </Box>

//       <Grid container spacing={3}>
//         {/* Main Form - Left Side */}
//         <Grid size={{ xs: 12, md: 8 }}>
//           <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
//             {/* User Information Section */}
//             <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
//               User Information
//             </Typography>
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField
//                   fullWidth
//                   label="Full Name *"
//                   value={formData.name}
//                   onChange={(e) => handleChange('name', e.target.value)}
//                   required
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <Person sx={{ fontSize: 20, color: '#94a3b8' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField
//                   fullWidth
//                   label="Work Email *"
//                   type="email"
//                   value={formData.email}
//                   onChange={(e) => handleChange('email', e.target.value)}
//                   required
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <Email sx={{ fontSize: 20, color: '#94a3b8' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField
//                   fullWidth
//                   label="Job Title"
//                   value={formData.job_title}
//                   onChange={(e) => handleChange('job_title', e.target.value)}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <Work sx={{ fontSize: 20, color: '#94a3b8' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <FormControl fullWidth>
//                   <InputLabel>Department</InputLabel>
//                   <Select
//                     value={formData.department || ''}
//                     onChange={(e) => handleChange('department', e.target.value)}
//                     label="Department"
//                     startAdornment={
//                       <InputAdornment position="start">
//                         <Business sx={{ fontSize: 20, color: '#94a3b8' }} />
//                       </InputAdornment>
//                     }
//                   >
//                     <MenuItem value="">None</MenuItem>
//                     {DEPARTMENTS.map(dept => (
//                       <MenuItem key={dept} value={dept}>{dept}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField
//                   fullWidth
//                   label="Phone Number (Optional)"
//                   value={formData.phone_number}
//                   onChange={(e) => handleChange('phone_number', e.target.value)}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <Phone sx={{ fontSize: 20, color: '#94a3b8' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <FormControl fullWidth>
//                   <InputLabel>Location (Optional)</InputLabel>
//                   <Select
//                     value={formData.location || ''}
//                     onChange={(e) => handleChange('location', e.target.value)}
//                     label="Location (Optional)"
//                     startAdornment={
//                       <InputAdornment position="start">
//                         <LocationOn sx={{ fontSize: 20, color: '#94a3b8' }} />
//                       </InputAdornment>
//                     }
//                   >
//                     <MenuItem value="">None</MenuItem>
//                     {LOCATIONS.map(loc => (
//                       <MenuItem key={loc} value={loc}>{loc}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>

//             <Divider sx={{ my: 3 }} />

//             {/* Account Settings */}
//             <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
//               Account Settings
//             </Typography>
//             <Box sx={{ mb: 3 }}>
//               <FormControlLabel
//                 control={
//                   <Switch
//                     checked={formData.send_invite}
//                     onChange={(e) => handleChange('send_invite', e.target.checked)}
//                   />
//                 }
//                 label="Send invite email"
//               />
//               <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: -1, ml: 4 }}>
//                 User will receive an email invitation to join
//               </Typography>
//             </Box>

//             <Divider sx={{ my: 3 }} />

//             {/* Role & Permissions */}
//             <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
//               Role & Permissions
//             </Typography>
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid size={{ xs: 12 }}>
//                 <FormControl fullWidth>
//                   <InputLabel>Assign Role</InputLabel>
//                   <Select
//                     value={formData.role}
//                     onChange={(e) => handleChange('role', e.target.value)}
//                     label="Assign Role"
//                   >
//                     {ROLES.map(role => (
//                       <MenuItem key={role.value} value={role.value}>
//                         <Box>
//                           <Typography variant="body2" fontWeight={500}>{role.label}</Typography>
//                           <Typography variant="caption" color="text.secondary">{role.description}</Typography>
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>

//             <Divider sx={{ my: 3 }} />

//             {/* Data Operations */}
//             <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
//               Data Operations
//             </Typography>
//             <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
//               Define what operations the user can perform in the platform.
//             </Typography>
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid size={{ xs: 6, md: 4 }}>
//                 <FormControlLabel
//                   control={<Switch checked={true} disabled />}
//                   label="View Data"
//                 />
//               </Grid>
//               <Grid size={{ xs: 6, md: 4 }}>
//                 <FormControlLabel
//                   control={<Switch checked={formData.role !== 'viewer'} disabled={formData.role === 'viewer'} />}
//                   label="Edit Data"
//                 />
//               </Grid>
//               <Grid size={{ xs: 6, md: 4 }}>
//                 <FormControlLabel
//                   control={<Switch checked={formData.role === 'admin'} disabled={formData.role !== 'admin'} />}
//                   label="Delete Data"
//                 />
//               </Grid>
//               <Grid size={{ xs: 6, md: 4 }}>
//                 <FormControlLabel
//                   control={<Switch checked={true} disabled />}
//                   label="Export Data"
//                 />
//               </Grid>
//               <Grid size={{ xs: 6, md: 4 }}>
//                 <FormControlLabel
//                   control={<Switch checked={formData.role === 'admin'} disabled={formData.role !== 'admin'} />}
//                   label="System Settings Access"
//                 />
//               </Grid>
//             </Grid>

//             <Divider sx={{ my: 3 }} />

//             {/* Data Access Scope */}
//             <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
//               Data Access
//             </Typography>
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid size={{ xs: 12 }}>
//                 <FormControl component="fieldset">
//                   <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
//                     <FormControlLabel
//                       control={
//                         <Radio
//                           checked={dataAccessScope === 'all'}
//                           onChange={() => setDataAccessScope('all')}
//                         />
//                       }
//                       label="All Data"
//                     />
//                     <FormControlLabel
//                       control={
//                         <Radio
//                           checked={dataAccessScope === 'restricted'}
//                           onChange={() => setDataAccessScope('restricted')}
//                         />
//                       }
//                       label="Restricted Access"
//                     />
//                     <FormControlLabel
//                       control={
//                         <Radio
//                           checked={dataAccessScope === 'custom'}
//                           onChange={() => setDataAccessScope('custom')}
//                         />
//                       }
//                       label="Custom Scope"
//                     />
//                   </Box>
//                   <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
//                     {dataAccessScope === 'all' && 'User can access all data in the platform'}
//                     {dataAccessScope === 'restricted' && 'User can access only specific data'}
//                     {dataAccessScope === 'custom' && 'Define custom data restrictions'}
//                   </Typography>
//                 </FormControl>
//               </Grid>
//             </Grid>

//             {/* Data Restrictions - Visible when not 'all' */}
//             {(dataAccessScope === 'restricted' || dataAccessScope === 'custom') && (
//               <>
//                 <Divider sx={{ my: 3 }} />
//                 <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
//                   Data Restrictions
//                 </Typography>
//                 <Grid container spacing={2}>
//                   <Grid size={{ xs: 12, md: 6 }}>
//                     <FormControl fullWidth>
//                       <InputLabel>Business Units</InputLabel>
//                       <Select
//                         multiple
//                         value={selectedBusinessUnits}
//                         onChange={(e) => setSelectedBusinessUnits(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
//                         input={<OutlinedInput label="Business Units" />}
//                         renderValue={(selected) => (
//                           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                             {(selected as string[]).map((value) => (
//                               <Chip key={value} label={value} size="small" />
//                             ))}
//                           </Box>
//                         )}
//                       >
//                         {BUSINESS_UNITS.map((unit) => (
//                           <MenuItem key={unit} value={unit}>
//                             {unit}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid size={{ xs: 12, md: 6 }}>
//                     <FormControl fullWidth>
//                       <InputLabel>Vendors</InputLabel>
//                       <Select
//                         multiple
//                         value={selectedVendors}
//                         onChange={(e) => setSelectedVendors(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
//                         input={<OutlinedInput label="Vendors" />}
//                         renderValue={(selected) => (
//                           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                             {(selected as string[]).map((value) => (
//                               <Chip key={value} label={value} size="small" />
//                             ))}
//                           </Box>
//                         )}
//                       >
//                         <MenuItem value="All">All Vendors</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid size={{ xs: 12, md: 6 }}>
//                     <FormControl fullWidth>
//                       <InputLabel>Risk Groups</InputLabel>
//                       <Select
//                         multiple
//                         value={selectedRiskGroups}
//                         onChange={(e) => setSelectedRiskGroups(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
//                         input={<OutlinedInput label="Risk Groups" />}
//                         renderValue={(selected) => (
//                           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                             {(selected as string[]).map((value) => (
//                               <Chip key={value} label={value} size="small" />
//                             ))}
//                           </Box>
//                         )}
//                       >
//                         <MenuItem value="High Risk">High Risk</MenuItem>
//                         <MenuItem value="Medium Risk">Medium Risk</MenuItem>
//                         <MenuItem value="Low Risk">Low Risk</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid size={{ xs: 12, md: 6 }}>
//                     <FormControl fullWidth>
//                       <InputLabel>Vendor Categories</InputLabel>
//                       <Select
//                         multiple
//                         value={selectedVendorCategories}
//                         onChange={(e) => setSelectedVendorCategories(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
//                         input={<OutlinedInput label="Vendor Categories" />}
//                         renderValue={(selected) => (
//                           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                             {(selected as string[]).map((value) => (
//                               <Chip key={value} label={value} size="small" />
//                             ))}
//                           </Box>
//                         )}
//                       >
//                         {VENDOR_CATEGORIES.map((cat) => (
//                           <MenuItem key={cat} value={cat}>
//                             {cat}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid size={{ xs: 12, md: 6 }}>
//                     <FormControl fullWidth>
//                       <InputLabel>Geographies</InputLabel>
//                       <Select
//                         multiple
//                         value={selectedGeographies}
//                         onChange={(e) => setSelectedGeographies(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
//                         input={<OutlinedInput label="Geographies" />}
//                         renderValue={(selected) => (
//                           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                             {(selected as string[]).map((value) => (
//                               <Chip key={value} label={value} size="small" />
//                             ))}
//                           </Box>
//                         )}
//                       >
//                         {GEOGRAPHIES.map((geo) => (
//                           <MenuItem key={geo} value={geo}>
//                             {geo}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid size={{ xs: 12, md: 6 }}>
//                     <FormControl fullWidth>
//                       <InputLabel>Criticality Levels</InputLabel>
//                       <Select
//                         multiple
//                         value={selectedCriticalityLevels}
//                         onChange={(e) => setSelectedCriticalityLevels(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
//                         input={<OutlinedInput label="Criticality Levels" />}
//                         renderValue={(selected) => (
//                           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                             {(selected as string[]).map((value) => (
//                               <Chip key={value} label={value} size="small" />
//                             ))}
//                           </Box>
//                         )}
//                       >
//                         {CRITICALITY_LEVELS.map((level) => (
//                           <MenuItem key={level} value={level}>
//                             {level}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </>
//             )}

//             <Divider sx={{ my: 3 }} />

//             {/* Session Management */}
//             <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
//               Session Management
//             </Typography>
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField
//                   fullWidth
//                   label="Max Active Sessions"
//                   type="number"
//                   value={formData.max_active_sessions}
//                   onChange={(e) => handleChange('max_active_sessions', parseInt(e.target.value) || 3)}
//                   helperText="User can be logged in on this many devices at the same time"
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <Security sx={{ fontSize: 20, color: '#94a3b8' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField
//                   fullWidth
//                   label="Session Timeout (hours)"
//                   type="number"
//                   value={formData.session_timeout_hours}
//                   onChange={(e) => handleChange('session_timeout_hours', parseInt(e.target.value) || 8)}
//                   helperText="Automatically log out inactive sessions after this time"
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <Schedule sx={{ fontSize: 20, color: '#94a3b8' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>
//             </Grid>

//             <Divider sx={{ my: 3 }} />

//             {/* Additional Settings */}
//             <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
//               Additional Settings
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <FormControlLabel
//                   control={
//                     <Switch
//                       checked={formData.receive_notifications}
//                       onChange={(e) => handleChange('receive_notifications', e.target.checked)}
//                     />
//                   }
//                   label="Receive security notifications"
//                 />
//                 <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: -1, ml: 4 }}>
//                   Send important security and risk alerts
//                 </Typography>
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <FormControlLabel
//                   control={
//                     <Switch
//                       checked={formData.api_access}
//                       onChange={(e) => handleChange('api_access', e.target.checked)}
//                     />
//                   }
//                   label="API Access"
//                 />
//                 <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: -1, ml: 4 }}>
//                   Allow user to generate API keys and access API
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         {/* Right Sidebar - Info */}
//         <Grid size={{ xs: 12, md: 4 }}>
//           <Paper sx={{ p: 3, borderRadius: 2, position: 'sticky', top: 24 }}>
//             <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Info sx={{ color: '#1a56db' }} />
//               What happens next?
//             </Typography>
//             <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//               After creating the user, they will receive an email invitation to join the platform.
//             </Typography>
//             <Divider sx={{ my: 2 }} />
//             <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
//               The user will be able to:
//             </Typography>
//             <Box component="ul" sx={{ pl: 2, mb: 2 }}>
//               <Typography component="li" variant="body2" color="text.secondary">Access the TPRM platform</Typography>
//               <Typography component="li" variant="body2" color="text.secondary">View assigned vendors and data</Typography>
//               <Typography component="li" variant="body2" color="text.secondary">Run security scans (based on role)</Typography>
//               <Typography component="li" variant="body2" color="text.secondary">Generate compliance reports</Typography>
//             </Box>
//             <Button
//               fullWidth
//               variant="contained"
//               size="large"
//               onClick={handleSubmit}
//               disabled={loading}
//               startIcon={loading ? <CircularProgress size={20} /> : <Save />}
//               sx={{ mt: 2, textTransform: 'none', py: 1.5 }}
//             >
//               {loading ? 'Creating...' : 'Create User'}
//             </Button>
//             <Button
//               fullWidth
//               variant="outlined"
//               size="large"
//               onClick={() => navigate('/users')}
//               sx={{ mt: 1, textTransform: 'none', py: 1.5 }}
//             >
//               Cancel
//             </Button>
//           </Paper>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// }
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Switch,
  FormControlLabel,
  Divider,
  Alert,
  CircularProgress,
  InputAdornment,
  Chip,
  OutlinedInput,
  SelectChangeEvent,
  IconButton,
  Tooltip,
  Radio,
  RadioGroup,
} from '@mui/material';
import {
  Save,
  ArrowBack,
  Person,
  Email,
  Work,
  Business,
  Phone,
  LocationOn,
  Security,
  Schedule,
  Notifications,
  Api,
  Info,
  Add,
  Delete,
  CheckCircle,
  Error as ErrorIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useMutation } from '@tanstack/react-query';
import userApi, { CreateUserData } from '../../services/userApi';
import MuiPhoneNumberInput from '../../components/MuiPhoneNumberInput';

// Options for dropdowns
const ROLES = [
  { value: 'admin', label: 'Admin', description: 'Full system access including user management' },
  { value: 'risk_analyst', label: 'Risk Analyst', description: 'Can view vendor risk data, run scans, analyze indicators, and generate reports' },
  { value: 'viewer', label: 'Viewer', description: 'Read-only access to vendor risk data' },
  { value: 'compliance_officer', label: 'Compliance Officer', description: 'Focus on compliance and regulatory indicators' },
];

const DEPARTMENTS = ['IT', 'Security', 'Compliance', 'Risk Management', 'Finance', 'Legal', 'Operations', 'HR', 'Marketing', 'Sales'];
const LOCATIONS = ['North America', 'EMEA', 'APAC', 'LATAM', 'Global'];
const BUSINESS_UNITS = ['North America', 'EMEA', 'APAC', 'LATAM'];
const VENDOR_CATEGORIES = ['Cloud Services', 'Technology Services', 'Logistics', 'Healthcare', 'Data & Analytics', 'Telecommunications', 'HR Services', 'IT Services', 'Finance', 'Legal', 'Cybersecurity'];
const GEOGRAPHIES = ['North America', 'South America', 'Europe', 'Asia', 'Africa', 'Australia'];
const CRITICALITY_LEVELS = ['Low', 'Medium', 'High', 'Critical'];

export default function AddUser() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const createMutation = useMutation({
    mutationFn: (data: CreateUserData) => userApi.createUser(data),
    meta: { invalidates: [['users']] },
  });
  const loading = createMutation.isPending;
  const [emailError, setEmailError] = useState<string>('');
  const [formData, setFormData] = useState<CreateUserData>({
    name: '',
    email: '',
    role: 'risk_analyst',
    job_title: '',
    department: '',
    phone_number: '',
    location: '',
    max_active_sessions: 3,
    session_timeout_hours: 8,
    receive_notifications: true,
    api_access: false,
    send_invite: true,
  });

  // Data restrictions state
  const [dataAccessScope, setDataAccessScope] = useState<'all' | 'restricted' | 'custom'>('all');
  const [selectedBusinessUnits, setSelectedBusinessUnits] = useState<string[]>([]);
  const [selectedVendors, setSelectedVendors] = useState<string[]>([]);
  const [selectedRiskGroups, setSelectedRiskGroups] = useState<string[]>([]);
  const [selectedVendorCategories, setSelectedVendorCategories] = useState<string[]>([]);
  const [selectedGeographies, setSelectedGeographies] = useState<string[]>([]);
  const [selectedCriticalityLevels, setSelectedCriticalityLevels] = useState<string[]>([]);

  const handleChange = (field: keyof CreateUserData, value: any) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    
    // Clear email error when user types
    if (field === 'email') {
      setEmailError('');
    }
  };

  const handleSubmit = async () => {
  if (!formData.name || !formData.email) {
    enqueueSnackbar('Please fill in all required fields', { variant: 'error' });
    return;
  }

  try {
    await createMutation.mutateAsync(formData);
    enqueueSnackbar('User created successfully! Invitation sent.', { variant: 'success' });
    navigate('/users');
  } catch (error: any) {
    console.log('🔍 Full error object:', error);
    console.log('🔍 Error response:', error.response);
    console.log('🔍 Error response data:', error.response?.data);
    console.log('🔍 Error status:', error.response?.status);
    
    // ─── GET ERROR MESSAGE ──────────────────────────────────────────────────
    let errorMsg = 'Failed to create user';

    // detail can be a string, a 422 validation array, or a structured object (e.g. the AI-guard
    // 412's {code, ai_mode, message}) -- only ever take a string out of it, never render it raw.
    const rawDetail = error.response?.data?.detail;
    if (typeof rawDetail === 'string') {
      errorMsg = rawDetail;
    } else if (rawDetail && typeof rawDetail === 'object' && typeof rawDetail.message === 'string') {
      errorMsg = rawDetail.message;
    } else if (error.response?.data?.message) {
      errorMsg = error.response.data.message;
    } else if (error.message) {
      errorMsg = error.message;
    }
    
    console.log('🔍 Error message:', errorMsg);
    
    // ─── HANDLE DIFFERENT ERROR TYPES ──────────────────────────────────────
    if (errorMsg.includes('User limit reached') || errorMsg.includes('limit reached')) {
      enqueueSnackbar(errorMsg, { 
        variant: 'warning',
        autoHideDuration: 8000,
        action: (
          <Button 
            color="inherit" 
            size="small" 
            onClick={() => navigate('/settings')}
          >
            Upgrade Plan
          </Button>
        )
      });
    } else if (errorMsg.includes('domain') || errorMsg.includes('same domain')) {
      setEmailError(errorMsg);
      enqueueSnackbar(errorMsg, { variant: 'warning', autoHideDuration: 8000 });
    } else {
      enqueueSnackbar(errorMsg, { variant: 'error' });
    }
  }
};

  return (
    <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh', p: 3 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
          <IconButton onClick={() => navigate('/users')} sx={{ color: '#64748b' }}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h4" sx={{ fontWeight: 700, color: '#0f172a' }}>
            Add New User
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ color: '#64748b', ml: 7 }}>
          Create a new user and define their role, permissions and data access.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {/* Main Form - Left Side */}
        <Grid size={{ xs: 12, md: 8 }}>
          <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
            {/* User Information Section */}
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
              User Information
            </Typography>
            
            {/* Domain Info Alert */}
            <Alert 
              severity="info" 
              icon={<Info />}
              sx={{ mb: 3, borderRadius: 2 }}
            >
              <Typography variant="body2">
                <strong>Domain Requirement:</strong> Users must have an email address from 
                your organization's domain. This ensures only authorized team members can join.
              </Typography>
            </Alert>

            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Full Name *"
                  value={formData.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Person sx={{ fontSize: 20, color: '#94a3b8' }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Work Email *"
                  type="email"
                  value={formData.email}
                  onChange={(e) => handleChange('email', e.target.value)}
                  required
                  error={!!emailError}
                  helperText={emailError || "Must be from your organization's domain"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Email sx={{ fontSize: 20, color: '#94a3b8' }} />
                      </InputAdornment>
                    ),
                    endAdornment: formData.email && !emailError && (
                      <InputAdornment position="end">
                        <CheckCircle sx={{ fontSize: 20, color: '#22c55e' }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Job Title"
                  value={formData.job_title}
                  onChange={(e) => handleChange('job_title', e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Work sx={{ fontSize: 20, color: '#94a3b8' }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <FormControl fullWidth>
                  <InputLabel>Department</InputLabel>
                  <Select
                    value={formData.department || ''}
                    onChange={(e) => handleChange('department', e.target.value)}
                    label="Department"
                    startAdornment={
                      <InputAdornment position="start">
                        <Business sx={{ fontSize: 20, color: '#94a3b8' }} />
                      </InputAdornment>
                    }
                  >
                    <MenuItem value="">None</MenuItem>
                    {DEPARTMENTS.map(dept => (
                      <MenuItem key={dept} value={dept}>{dept}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <MuiPhoneNumberInput value={formData.phone_number || ''} onChange={v => handleChange('phone_number', v)} />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <FormControl fullWidth>
                  <InputLabel>Location (Optional)</InputLabel>
                  <Select
                    value={formData.location || ''}
                    onChange={(e) => handleChange('location', e.target.value)}
                    label="Location (Optional)"
                    startAdornment={
                      <InputAdornment position="start">
                        <LocationOn sx={{ fontSize: 20, color: '#94a3b8' }} />
                      </InputAdornment>
                    }
                  >
                    <MenuItem value="">None</MenuItem>
                    {LOCATIONS.map(loc => (
                      <MenuItem key={loc} value={loc}>{loc}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            {/* Account Settings */}
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
              Account Settings
            </Typography>
            <Box sx={{ mb: 3 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.send_invite}
                    onChange={(e) => handleChange('send_invite', e.target.checked)}
                  />
                }
                label="Send invite email"
              />
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: -1, ml: 4 }}>
                User will receive an email invitation with a temporary password
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Role & Permissions */}
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
              Role & Permissions
            </Typography>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid size={{ xs: 12 }}>
                <FormControl fullWidth>
                  <InputLabel>Assign Role</InputLabel>
                  <Select
                    value={formData.role}
                    onChange={(e) => handleChange('role', e.target.value)}
                    label="Assign Role"
                  >
                    {ROLES.map(role => (
                      <MenuItem key={role.value} value={role.value}>
                        <Box>
                          <Typography variant="body2" fontWeight={500}>{role.label}</Typography>
                          <Typography variant="caption" color="text.secondary">{role.description}</Typography>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            {/* Data Operations */}
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
              Data Operations
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
              Define what operations the user can perform in the platform.
            </Typography>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid size={{ xs: 6, md: 4 }}>
                <FormControlLabel
                  control={<Switch checked={true} disabled />}
                  label="View Data"
                />
              </Grid>
              <Grid size={{ xs: 6, md: 4 }}>
                <FormControlLabel
                  control={<Switch checked={formData.role !== 'viewer'} disabled={formData.role === 'viewer'} />}
                  label="Edit Data"
                />
              </Grid>
              <Grid size={{ xs: 6, md: 4 }}>
                <FormControlLabel
                  control={<Switch checked={formData.role === 'admin'} disabled={formData.role !== 'admin'} />}
                  label="Delete Data"
                />
              </Grid>
              <Grid size={{ xs: 6, md: 4 }}>
                <FormControlLabel
                  control={<Switch checked={true} disabled />}
                  label="Export Data"
                />
              </Grid>
              <Grid size={{ xs: 6, md: 4 }}>
                <FormControlLabel
                  control={<Switch checked={formData.role === 'admin'} disabled={formData.role !== 'admin'} />}
                  label="System Settings Access"
                />
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            {/* Data Access Scope */}
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
              Data Access
            </Typography>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid size={{ xs: 12 }}>
                <FormControl component="fieldset">
                  <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                    <FormControlLabel
                      control={
                        <Radio
                          checked={dataAccessScope === 'all'}
                          onChange={() => setDataAccessScope('all')}
                        />
                      }
                      label="All Data"
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          checked={dataAccessScope === 'restricted'}
                          onChange={() => setDataAccessScope('restricted')}
                        />
                      }
                      label="Restricted Access"
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          checked={dataAccessScope === 'custom'}
                          onChange={() => setDataAccessScope('custom')}
                        />
                      }
                      label="Custom Scope"
                    />
                  </Box>
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
                    {dataAccessScope === 'all' && 'User can access all data in the platform'}
                    {dataAccessScope === 'restricted' && 'User can access only specific data'}
                    {dataAccessScope === 'custom' && 'Define custom data restrictions'}
                  </Typography>
                </FormControl>
              </Grid>
            </Grid>

            {/* Data Restrictions - Visible when not 'all' */}
            {(dataAccessScope === 'restricted' || dataAccessScope === 'custom') && (
              <>
                <Divider sx={{ my: 3 }} />
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
                  Data Restrictions
                </Typography>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <FormControl fullWidth>
                      <InputLabel>Business Units</InputLabel>
                      <Select
                        multiple
                        value={selectedBusinessUnits}
                        onChange={(e) => setSelectedBusinessUnits(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                        input={<OutlinedInput label="Business Units" />}
                        renderValue={(selected) => (
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {(selected as string[]).map((value) => (
                              <Chip key={value} label={value} size="small" />
                            ))}
                          </Box>
                        )}
                      >
                        {BUSINESS_UNITS.map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <FormControl fullWidth>
                      <InputLabel>Vendors</InputLabel>
                      <Select
                        multiple
                        value={selectedVendors}
                        onChange={(e) => setSelectedVendors(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                        input={<OutlinedInput label="Vendors" />}
                        renderValue={(selected) => (
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {(selected as string[]).map((value) => (
                              <Chip key={value} label={value} size="small" />
                            ))}
                          </Box>
                        )}
                      >
                        <MenuItem value="All">All Vendors</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <FormControl fullWidth>
                      <InputLabel>Risk Groups</InputLabel>
                      <Select
                        multiple
                        value={selectedRiskGroups}
                        onChange={(e) => setSelectedRiskGroups(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                        input={<OutlinedInput label="Risk Groups" />}
                        renderValue={(selected) => (
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {(selected as string[]).map((value) => (
                              <Chip key={value} label={value} size="small" />
                            ))}
                          </Box>
                        )}
                      >
                        <MenuItem value="High Risk">High Risk</MenuItem>
                        <MenuItem value="Medium Risk">Medium Risk</MenuItem>
                        <MenuItem value="Low Risk">Low Risk</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <FormControl fullWidth>
                      <InputLabel>Vendor Categories</InputLabel>
                      <Select
                        multiple
                        value={selectedVendorCategories}
                        onChange={(e) => setSelectedVendorCategories(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                        input={<OutlinedInput label="Vendor Categories" />}
                        renderValue={(selected) => (
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {(selected as string[]).map((value) => (
                              <Chip key={value} label={value} size="small" />
                            ))}
                          </Box>
                        )}
                      >
                        {VENDOR_CATEGORIES.map((cat) => (
                          <MenuItem key={cat} value={cat}>
                            {cat}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <FormControl fullWidth>
                      <InputLabel>Geographies</InputLabel>
                      <Select
                        multiple
                        value={selectedGeographies}
                        onChange={(e) => setSelectedGeographies(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                        input={<OutlinedInput label="Geographies" />}
                        renderValue={(selected) => (
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {(selected as string[]).map((value) => (
                              <Chip key={value} label={value} size="small" />
                            ))}
                          </Box>
                        )}
                      >
                        {GEOGRAPHIES.map((geo) => (
                          <MenuItem key={geo} value={geo}>
                            {geo}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <FormControl fullWidth>
                      <InputLabel>Criticality Levels</InputLabel>
                      <Select
                        multiple
                        value={selectedCriticalityLevels}
                        onChange={(e) => setSelectedCriticalityLevels(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                        input={<OutlinedInput label="Criticality Levels" />}
                        renderValue={(selected) => (
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {(selected as string[]).map((value) => (
                              <Chip key={value} label={value} size="small" />
                            ))}
                          </Box>
                        )}
                      >
                        {CRITICALITY_LEVELS.map((level) => (
                          <MenuItem key={level} value={level}>
                            {level}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </>
            )}

            <Divider sx={{ my: 3 }} />

            {/* Session Management */}
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
              Session Management
            </Typography>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Max Active Sessions"
                  type="number"
                  value={formData.max_active_sessions}
                  onChange={(e) => handleChange('max_active_sessions', parseInt(e.target.value) || 3)}
                  helperText="User can be logged in on this many devices at the same time"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Security sx={{ fontSize: 20, color: '#94a3b8' }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Session Timeout (hours)"
                  type="number"
                  value={formData.session_timeout_hours}
                  onChange={(e) => handleChange('session_timeout_hours', parseInt(e.target.value) || 8)}
                  helperText="Automatically log out inactive sessions after this time"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Schedule sx={{ fontSize: 20, color: '#94a3b8' }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            {/* Additional Settings */}
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1a56db' }}>
              Additional Settings
            </Typography>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.receive_notifications}
                      onChange={(e) => handleChange('receive_notifications', e.target.checked)}
                    />
                  }
                  label="Receive security notifications"
                />
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: -1, ml: 4 }}>
                  Send important security and risk alerts
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.api_access}
                      onChange={(e) => handleChange('api_access', e.target.checked)}
                    />
                  }
                  label="API Access"
                />
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: -1, ml: 4 }}>
                  Allow user to generate API keys and access API
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Right Sidebar - Info */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Paper sx={{ p: 3, borderRadius: 2, position: 'sticky', top: 24 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Info sx={{ color: '#1a56db' }} />
              What happens next?
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              After creating the user, they will receive an email invitation with a temporary password to join the platform.
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
              The user will be able to:
            </Typography>
            <Box component="ul" sx={{ pl: 2, mb: 2 }}>
              <Typography component="li" variant="body2" color="text.secondary">Access the TPRM platform</Typography>
              <Typography component="li" variant="body2" color="text.secondary">View assigned vendors and data</Typography>
              <Typography component="li" variant="body2" color="text.secondary">Run security scans (based on role)</Typography>
              <Typography component="li" variant="body2" color="text.secondary">Generate compliance reports</Typography>
            </Box>
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={handleSubmit}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : <Save />}
              sx={{ mt: 2, textTransform: 'none', py: 1.5 }}
            >
              {loading ? 'Creating...' : 'Create User'}
            </Button>
            <Button
              fullWidth
              variant="outlined"
              size="large"
              onClick={() => navigate('/users')}
              sx={{ mt: 1, textTransform: 'none', py: 1.5 }}
            >
              Cancel
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}